// Container

export default function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto w-full max-w-7xl px-5 md:px-8 ${className}`}>
      {children}
    </div>
  );
}